export enum Authorization {
    tsso = 't-sso=true',
    telekomAad = 'telekomaad'
  }
